// Copyright (c) 2017 Davide Gironi
// Please refer to LICENSE file for licensing information.

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Modal, Button } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';

/**
 * Show a Message dialog
 */
export default function ShowMessages({ title, mode, messages = [], onClose }) {
    const { t } = useTranslation('translation', { keyPrefix: 'showmessages' });

    // states
    const [show, setShow] = useState(true);

    // set message vars
    let headerColor = "var(--bs-primary)";
    let titletext = title;
    const messagetext =
        messages != null ? messages.map((message) => <div key={uuidv4()}>{message}</div>) : null;
    if (mode === 'E') {
        headerColor = "var(--bs-danger)";
    } else if (mode === 'I') {
        headerColor = "var(--bs-primary)";
    }

    // prevent show if nothing to show
    useEffect(() => {
        if (titletext === "" || messagetext === "")
            setShow(false);
    }, []);

    return (
        <Modal
            show={show}
            onHide={() => {
                setShow(false);
                if (onClose != null)
                    onClose();
            }}
            size="large"
        >
            {titletext != null ?
                <Modal.Header style={{ color: headerColor }}>
                    <Modal.Title >{titletext}</Modal.Title>
                </Modal.Header>
                : null}
            <Modal.Body>{messagetext}</Modal.Body>
            <Modal.Footer>
                <Button onClick={() => {
                    setShow(false);
                    if (onClose != null)
                        onClose();
                }}>
                    {t('close')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

ShowMessages.propTypes = {
    title: PropTypes.string,
    mode: PropTypes.string,
    messages: PropTypes.array,
    onClose: PropTypes.func
};
ShowMessages.defaultProps = {
    title: null,
    mode: null,
    messages: [],
    onClose: null
};